import { render, staticRenderFns } from "./TestPackingRules.vue?vue&type=template&id=8e8006da&scoped=true"
import script from "./TestPackingRules.vue?vue&type=script&lang=js"
export * from "./TestPackingRules.vue?vue&type=script&lang=js"
import style0 from "./TestPackingRules.vue?vue&type=style&index=0&id=8e8006da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8006da",
  null
  
)

export default component.exports